import React from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import { InformationHeading } from './heading';

/**
 * Number of warnings to display
 * Must correspond with locale file
 */
const numberOfWarnings = 12;

const Container = styled.div``;

const List = styled.ol`
  margin: 2em 0 0;
`;

const Text = styled.li`
  color: #e0e0e0;
  font-size: 0.9em;
  letter-spacing: 0.1em;
  line-height: 1.5;
  margin: 0.7em 0;
  text-align: left;
`;

/**
 * Warning section
 */
const Warning = () => (
  <Container>
    <InformationHeading>
      <Translate id="landingPage.warning.subtitle" />
    </InformationHeading>
    <List>
      {Array.from(Array(numberOfWarnings).keys()).map(i => (
        <Text key={i}>
          <Translate id={`landingPage.warning.${i + 1}`} />
        </Text>
      ))}
    </List>
  </Container>
);

export default Warning;
